module.exports = __webpack_public_path__ + "img/back_red.9194c14a.svg";